<template>
    <v-speed-dial
            v-model="chatDialog"
            bottom
            right
            fixed
            :style="`bottom: ${($vuetify.breakpoint.smAndDown ? 72 : 16) + chatOffset}px`"
            :class="$vuetify.breakpoint.xsOnly ? 'speed-dial-xs': ''"

    >
        <template v-slot:activator>
            <v-btn
                    v-model="chatDialog"
                    color="primary"
                    :class="dark ? 'white--text' : 'black--text'"
                    fab
                    :x-large="$vuetify.breakpoint.smAndUp"
                    elevation="12"
            >
                <v-icon v-if="chatDialog">mdi-close</v-icon>
                <v-icon v-else>mdi-message-outline</v-icon>
            </v-btn>
        </template>

        <v-card width="100%" @click.native.stop.prevent="" :loading="loading" :disabled="loading" elevation="12"
                style="position: relative">
            <v-snackbar :color="snackbarColor" v-model="snackbarValue" absolute top>{{snackbarText}}</v-snackbar>
            <v-card-title class="primary--text">{{$t('room.chat.heading')}}</v-card-title>
            <v-card-text>
                <v-row align="center" no-gutters>
                    <v-col>
                        <v-form ref="form" lazy-validation>
                            <v-text-field :label="$t('room.chat.label')" v-model="message" :rules="rules"
                                          @keydown.enter.prevent="createQuestion" autocomplete="off" :validate-on-blur="true"></v-text-field>
                        </v-form>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn icon color="primary" @click="createQuestion">
                            <v-icon>mdi-send</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-speed-dial>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import gql from 'graphql-tag';
    import snackbar from '@/mixins/snackbar';


    export default {
        name: 'Chat',
        props: {
            id: [Number, String]
        },
        mixins: [snackbar],
        data: () => ( {
            chatDialog: false,
            message: null,
            loading: false,
            sending: false,
            success: false,
            error: false,
        } ),
        computed: {
            ...mapState( ['event', 'chatOffset'] ),
            ...mapGetters( ['dark'] ),
            rules ()
            {
                return [
                    v => !!v || !this.sending || this.$t('room.chat.rules.required'),
                ];
            },
        },
        watch: {
            chatDialog() {
                this.message = null
            }
        },
        methods: {
            createQuestion ()
            {
                this.sending=true
                if ( this.$refs.form.validate() )
                {
                    let message = this.message;
                    let chat_id = this.id;
                    this.loading = true;
                    this.$apollo.mutate( {
                        // Query
                        mutation: gql`mutation ($chat_id: ID!, $message: String) {
                                createQuestion(chat_id: $chat_id, message: $message)
                              }`,
                        variables: {
                            chat_id: chat_id,
                            message: message,
                        },
                    } ).then( () =>
                    {
                        // Result
                        this.$refs.form.resetValidation();
                        this.$refs.form.reset();
                        this.loading = false;
                        this.showSuccessSnackbar(this.$t('room.chat.messages.success'))
                    } ).catch( () =>
                    {
                        this.error = true;
                        this.showGeneralErrorSnackbar()
                    } ).finally(()=>{
                        this.sending=false
                        this.loading = false;
                    });
                }
            },
        },
    };
</script>

<style scoped type="tex/scss">
    >>> .v-snack__wrapper {
        min-width: auto;
        width: 100%;
    }

    >>> .v-speed-dial__list {
        width: 480px !important;
        left: auto !important;
        right: 0;
    }

    .speed-dial-xs >>> .v-speed-dial__list {
        width: 300px !important;
    }

</style>